<template>
	<div
		class="w-max rounded-full px-2 text-sm font-bold text-white"
		:style="{
			backgroundColor: TaskTypeColor[type],
			color: TaskTypeContrastColor[type],
		}"
	>
		{{ t(TaskTypeNames[type]) }}
	</div>
</template>

<script setup lang="ts">
	import {
		TaskType,
		TaskTypeColor,
		TaskTypeContrastColor,
		TaskTypeNames,
	} from "seedgreen-shared/models/TaskType";
	import { useI18n } from "vue-i18n";

	const { t } = useI18n();

	interface Props {
		type: TaskType;
	}
	defineProps<Props>();
</script>
